import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("App error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink px-6 text-center">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-brand">
              Udat Marine Sdn Bhd
            </p>
            <h1 className="mt-4 font-display text-3xl uppercase tracking-tight">
              Something went adrift
            </h1>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-8 bg-brand px-8 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white transition-colors hover:bg-brand-hover"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
